export const TYPE_FLIGHT = 'flight';
export const TYPE_HOTEL = 'hotel';
export const TYPE_CAR = 'car';
export const TYPE_CRUISE = 'cruise';
export const TYPE_EVENT = 'event';
export const TYPE_SEAT = 'seat';
export const TYPE_SERVICE = 'service';
export const TYPE_STATIC_PRODUCT = 'static_product';
export const TYPE_TRANSFER = 'transfer';
export const TYPE_SEGMENT = 'segment';
